import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import AddIcon from '@mui/icons-material/Add';
import Chip from '@mui/material/Chip';

import MetadataService from '../../../../data/metadata-service';
import PopupMenu from '../../../../components/popupmenu';

const useStyles = makeStyles(theme => ({
    root: {
    },
    inlineChips: {
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: 5,
    },
    fuckoverflow: {
        position: 'fixed !important',
        top: 'auto !important',
        left: 'auto !important',
    }
}));

const SourceSelector = (props) => {
    const classes = useStyles();
    const [sources, setSources] = useState([]);

    useEffect(() => {
        // O(n x m) FTW
        setSources(Object.keys(MetadataService.sources)
            .filter(s => (props.sources || []).find(ss => ss === s) === undefined));
    }, [props.sources]);

    return (
        <React.Fragment>
            <PopupMenu
                items={sources}
                onSelect={props.onAdd}
                button={props.button}
                icon={<AddIcon/>}
                placement={'bottom-start'}
                wrap={'true'}/>
            {(props.sources || []).map((s, i) =>
                <div key={s} className={classes.inlineChips}>
                    <Chip
                        color="default"
                        label={s}
                        onDelete={() => props.onRemove(s)}
                        className={classes.chip}/>
                </div>
            )}
        </React.Fragment>
    );
};

SourceSelector.propTypes = {
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    sources: PropTypes.array,
    // override + button (must be a single React element with no children)
    button: PropTypes.node,
};

export default SourceSelector;
